import {Message} from '@/features/chat/chat.model'
import {SSEEventType} from './types'
import {
    broadcastMessageEventHandler,
    groupMessageEventHandler,
    messageEventHandler,
    removeMessageEventHandler,
    notificationEventHandler,
    unlockedAttachmentEventHandler,
    unlockedPaidMessageEventHandler,
    donateToGoalEventHandler
} from '@/features/chat/helpers/helpers'
import {UserV3} from '@/features/authentication/types'
import {NotificationsType} from '@/features/notifications/types'
import {GoalStatusesE} from '@/features/goal/types'

export type SSEEventHandlerProps = {
    message: Message
    user: UserV3
    creatorId: number
    followerId?: number
    groupId?: number
    chatIdentifier?: string
    broadcastGroupId?: number
}

export type SSEEventPaidMessageProps = {
    user: UserV3
    receiverId: number
    senderId: number
    paidMessageId?: number
    attachmentId?: number
}

export type SSEEventDonateGoalProps = {
    amount: number
    goalId: number
    newGoalAmount: number
    user: UserV3
    followerId: number
    goalStatus: GoalStatusesE
}

export const eventManager = {
    [SSEEventType.CHAT]: ({message, user, creatorId, followerId}: SSEEventHandlerProps) => {
        // Here should be new actions for received message
        !!followerId && messageEventHandler(message, user, creatorId, followerId)
    },
    [SSEEventType.PAID_CONNECTION_MESSAGE]: ({message, user, creatorId, followerId}: SSEEventHandlerProps) => {
        // Here should be new actions for received message
        !!followerId && messageEventHandler(message, user, creatorId, followerId)
    },
    [SSEEventType.CHAT_ATTACHMENT_UNLOCKED]: ({receiverId, senderId, user, attachmentId}: SSEEventPaidMessageProps) => {
        // Here should be new actions for received message
        unlockedAttachmentEventHandler(receiverId, senderId, user, attachmentId)
    },
    [SSEEventType.CHAT_PAID_MESSAGE_UNLOCKED]: ({
        receiverId,
        senderId,
        user,
        paidMessageId
    }: SSEEventPaidMessageProps) => {
        // Here should be new actions for received message
        unlockedPaidMessageEventHandler(receiverId, senderId, user, paidMessageId)
    },
    [SSEEventType.BROADCAST]: ({message, user, broadcastGroupId}: SSEEventHandlerProps) => {
        // Here should be new actions for received message
        !!broadcastGroupId && broadcastMessageEventHandler(message, user, broadcastGroupId)
    },
    [SSEEventType.GROUP]: ({message, user, groupId}: SSEEventHandlerProps) => {
        // Here should be new actions for received message
        !!groupId && groupMessageEventHandler(message, user, groupId)
    },
    [SSEEventType.NOTIFICATION]: (notification: NotificationsType) => {
        notificationEventHandler(notification)
    },
    [SSEEventType.CHAT_MESSAGE_DELETED]: ({message, user, chatIdentifier}: SSEEventHandlerProps) => {
        chatIdentifier && removeMessageEventHandler(message, user, chatIdentifier)
    },
    [SSEEventType.GOAL_DONATE]: (data: SSEEventDonateGoalProps) => {
        donateToGoalEventHandler(data)
    }
}
